export const TABS = {
  TOP_VIEW: "TOP_VIEW",
  FRONT_VIEW: "FRONT_VIEW",
};
